var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("yy-icon yy-icon-" + _vm.type),style:({
        fontSize: _vm.size
    })})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/base/icon/index.vue?vue&type=template&id=f6dd4b2c&
// module id = 112
// module chunks = 0